module.exports = __webpack_public_path__ + "img/step1.fc7f9892.png";